import React, { useState } from 'react';
import CreditOption from './CreditOption';
import PayButton from './PayButton';
import { Button } from 'antd';
import CustomValueModal from './CustomValueModal';
import { useStripe } from '@stripe/react-stripe-js';
import { insertCredits } from '../../services/account/api';
import { useAuth } from '../../contexts/auth';
import { createNotification } from '../Notification';
import { FormattedMessage, useIntl } from "react-intl";
import { useCredits } from '../../library/hooks/useCredits';

function Credit({ card, onFinish }) {
  const stripe = useStripe();
  const { RefreshUser } = useAuth();
  const intl = useIntl();

  const [isLoading, setLoading] = useState(false);
  const [customCreditModal, setCustomCreditModal] = useState(false);
  const {
    selectedAmount,
    updateSelectedAmount,
  } = useCredits();

  const creditOptions = [
    {
      value: 100,
      isCheck: selectedAmount === 100
    },
    {
      value: 200,
      isCheck: selectedAmount === 200
    },
    {
      value: 300,
      isCheck: selectedAmount === 300
    },
    {
      value: 400,
      isCheck: selectedAmount === 400
    },
    {
      value: 500,
      isCheck: selectedAmount === 500
    }
  ];

  const isCustomValue = () => {
    return !creditOptions.some(option => option.value === selectedAmount && option.isCheck);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true)

    insertCredits({ amount: `${selectedAmount}00`, payment_method_id: card.payment_method_id })
      .then((res) => {
        stripe.retrievePaymentIntent(res.clientSecret)
          .then(({ paymentIntent }) => {
            if (paymentIntent.status === 'succeeded') {
              createNotification("success", intl.formatMessage({
                id: "page.my_account.financial.successful_transaction",
              }));
              RefreshUser()
            } else {
              createNotification(
                "error",
                intl.formatMessage({
                  id: "page.my_account.financial.transaction_error",
                }),
                intl.formatMessage({
                  id: "page.my_account.financial.transaction_error.description",
                })
              );
            }
          })
      })
      .catch((err) => {
        createNotification(
          "error",
          intl.formatMessage({
            id: "page.my_account.financial.transaction_error",
          }),
          intl.formatMessage({
            id: "page.my_account.financial.transaction_error.description",
          })
        );
      })
      .finally(() => {
        setTimeout(() => {
          onFinish()
        }, 500)
        setLoading(false)
      });

  };

  return (
    <>
      <div className='grid gap-y-5'>
        <div className="grid grid-cols-3 gap-5">
          {creditOptions.map((option, key) => (
            <CreditOption key={key} onClick={(value) => updateSelectedAmount(value)} value={option.value} isCheck={option.isCheck} />
          ))}
          <Button
            className={`border-0 !text-xl text-white items-center text-center shadow-none ${isCustomValue() ? 'bg-primary' : 'bg-gray-200'}`}
            size="large"
            htmlType="submit"
            shape="round"
            onClick={() => setCustomCreditModal(true)}
            type="primary"
          >
            <FormattedMessage id="page.my_account.financial.other_value" />
          </Button>
        </div>
        <PayButton onClick={handleSubmit} disabled={!card} loading={isLoading} value={selectedAmount} />
      </div>
      <CustomValueModal
        open={customCreditModal}
        onCancel={() => setCustomCreditModal(false)}
        onSubmit={(value) => {
          setCustomCreditModal(false);
          updateSelectedAmount(value)
        }}
      />
    </>
  );
}

export default Credit;
